var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"code-box"},[_c('h5',[_vm._v("分享到微信")]),_vm._v(" "),_c('div',{attrs:{"id":"div_div"}},[_c('div',{ref:"qrCodeUrl",staticClass:"qrcode"})]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("用微信“扫一扫”，点击右上角分享按钮，"),_c('br'),_vm._v("即可将网页分享给您的微信好友或朋友圈。")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79873428","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Front/Code.vue
// module id = null
// module chunks = 